import React, { useState } from "react";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import SvgIcon from "../../../../../../Utils/CommonComponents/CommonIcons/CommonSvgIcons";
import { Href } from "../../../../../../Utils/Constants";
import { getAPIURL, getUserID } from "../../../../../../services/helper";
import {
  setLoading,
  UpdateBlocked,
  UpdateFriends,
} from "../../../../../../ReduxToolkit/Reducers/ChatReducer";
import http from "../../../../../../services/http";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";

const user_id = getUserID();
const api_url = getAPIURL();
export default function ContactEdit({ divClass, id }) {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prevState) => !prevState);
  const dispatch = useDispatch();

  const handleUnBlockUser = async () => {
    const data = {
      user_id,
      unblock_id: id,
    };
    try {
      dispatch(setLoading(true));
      const resp = await http.post(`${api_url}/chats/unblock`, data);

      if (resp.data.success) {
        toast.success("user unblocked successfully");
        const { block_list } = resp.data.data;
        dispatch(UpdateBlocked(block_list));
      } else {
        toast.error(resp.data.data);
      }
      dispatch(setLoading(false));
    } catch (error) {
      toast.error(error);
      dispatch(setLoading(false));
    }
  };

  return (
    <div className={`contact-edit ${divClass ? divClass : ""}`}>
      <Dropdown isOpen={dropdownOpen} toggle={toggle}>
        <DropdownToggle color="transparent d-flex align-items-center">
          <SvgIcon iconId="menubar" />
        </DropdownToggle>
        <DropdownMenu end={true}>
          <DropdownItem href={Href} onClick={handleUnBlockUser}>
            {"Unblock user"}
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
  );
}
